import { useEffect, useState } from 'react';
import { useGetSupplierPrepaymentReconciliationQuery } from '../Service/bankDocumentsService';
import { useGetBankDocumentApContractorsLookupQuery } from '../Service/apContractorsLookupApi';
import { getBankDocumentsErrorMessage } from '../Utils/bankDocumentsErrorMapping';

export const useSupplierPrepaymentReconciliationPage = () => {
  const { apContractors, isLoading: isApContractorsLoading } =
    useGetBankDocumentApContractorsLookupQuery();
  const [selectedApContractorId, setSelectedApContractorId] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    if (!selectedApContractorId && apContractors.length > 0) {
      setSelectedApContractorId(apContractors[0].id);
    }
  }, [apContractors, selectedApContractorId]);

  const reconciliationQuery = useGetSupplierPrepaymentReconciliationQuery(
    selectedApContractorId ?? 0,
    { skip: !selectedApContractorId }
  );

  const errorMessage = reconciliationQuery.error
    ? getBankDocumentsErrorMessage(
        reconciliationQuery.error,
        'Nie udało się wygenerować raportu rekoncyliacji.'
      )
    : null;

  return {
    apContractors,
    isApContractorsLoading,
    selectedApContractorId,
    setSelectedApContractorId,
    reconciliation: reconciliationQuery.data,
    isLoading: reconciliationQuery.isLoading || isApContractorsLoading,
    isFetching: reconciliationQuery.isFetching,
    errorMessage,
    refetch: reconciliationQuery.refetch,
  };
};
